import { useEffect, useState } from 'react'

import { addressFormat } from '../../../utils'
import { childUsers, userWiseRole } from '../../../utils/constant'
import { entries, include, isEqual, ternary } from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import { userChildrenList } from '../../layout/sidebar.description'
import { updateUserApi } from '../user.api'

const viewUser = ({ userDetails }) => {
  const {
    id,
    businessName,
    emailId,
    phoneNumber,
    roleId,
    lastName,
    name,
    parent,
    parentDetails,
    employeeId,
    companyCode,
    storeCode,
  } = {
    ...userDetails,
  }
  const [loader, setLoader] = useState(false)
  const [vehicleModelData, setVehicleModelData] = useState({ list: [] })
  const parentData = parent || parentDetails
  const currentUser = userChildrenList.find(val => isEqual(val.userId, roleId))
  const userListView = currentUser?.userView
  const loginUserRoleId = JSON.parse(getItem('userData'))?.roleId
  const {
    admin,
    storeOwner,
    store,
    storeManager,
    storeEmployee,
    vendor,
    manufacturer,
    customer,
  } = userWiseRole
  const allUser = [
    admin,
    storeOwner,
    store,
    storeManager,
    storeEmployee,
    vendor,
    manufacturer,
    customer,
  ]
  const PAGE_SIZE = 15

  useEffect(() => {
    // if (isEqual(roleId, manufacturer)) {
    if (isEqual(roleId, 1000)) {
      getVehicleModelList({ pageNo: 1 })
    }
  }, [userDetails?.id])

  const getVehicleModelList = async ({ pageNo = 1 }) => {
    if (!userDetails?.id) return

    setVehicleModelData(prev => ({ ...prev, loader: true }))

    // const payload = { producerId: userDetails?.id, pageSize: PAGE_SIZE }

    // const resp = await getVehicleModelListApi({
    //   params: payload,
    //   pageNo,
    // })

    setVehicleModelData(prev => ({
      // ...resp?.data,
      loader: false,
    }))
  }

  const onVehicleModelPageChange = current => {
    getVehicleModelList({ pageNo: current })
  }

  const updateVehicleModelList = async apiPayload => {
    setLoader(true)
    const payload = {
      userId: userDetails?.id,
      country: userDetails?.country,
      ...apiPayload,
    }

    const response = await updateUserApi({
      payload,
    })
    setLoader(false)

    if (!response?.data?.data?.success) return
    getVehicleModelList({ pageNo: vehicleModelData?.pageNo })
  }

  const handleDeleteModel = id => {
    updateVehicleModelList({
      modelIds: [id],
    })
  }

  const handleSaveModel = modelNames => {
    updateVehicleModelList({
      modelNames,
    })
  }

  const getEmailList = () => {
    const emailList = {}
    entries(userDetails).forEach(([key, value]) => {
      if (include(key, 'email') && value) {
        emailList[key] = value
      }
    })
    delete emailList.emailId
    return emailList
  }

  const basicInfoData = [
    { label: 'user_ID', value: id },
    {
      label: isEqual(roleId, storeOwner)
        ? 'job_CompanyName'
        : 'user_BusinessName',
      value: businessName,
      hidden: include([...childUsers, storeEmployee], roleId) || !roleId,
    },
    {
      label: 'user_CompanyCode',
      value: companyCode,
      hidden: !include([storeOwner], roleId),
    },
    {
      label: 'user_EmployeeID',
      value: employeeId,
      hidden: !include([storeEmployee], roleId),
    },
    {
      label: 'user_StoreCode',
      value: storeCode,
      hidden: !include([store], roleId),
    },
    {
      label: 'user_Name',
      value: ternary(roleId, lastName, name),
      hidden: include([store], roleId),
    },
    {
      label: 'user_Email',
      value: emailId,
      type: 'email',
    },
    { label: 'user_Contact', value: phoneNumber },
    {
      label: 'user_Address',
      value: addressFormat(userDetails),
      isBottomLine: true,
    },
  ]

  const parentInfoData = [
    { label: 'user_ID', value: parentData?.id },
    {
      label: 'user_BusinessName',
      value: parentData?.businessName,
    },
    { label: 'user_Name', value: parentData?.lastName },
    {
      label: 'user_Email',
      value: parentData?.emailId,
      type: 'email',
    },
    { label: 'user_Contact', value: parentData?.phoneNumber },
    {
      label: 'user_Address',
      value: addressFormat(parentData),
    },
  ]
  const otherDetail = [
    {
      label: 'user_DepartmentName',
      value: '',
      permission: allUser,
    },
    {
      label: 'user_InChargeName',
      value: '',
      className: 'border-bottom',
    },
  ]

  return {
    loader,
    parentData,
    otherDetail,
    userListView,
    basicInfoData,
    parentInfoData,
    loginUserRoleId,
    getEmailList,
    handleDeleteModel,
    handleSaveModel,
    vehicleModelData,
    onVehicleModelPageChange,
    PAGE_SIZE,
  }
}

export default viewUser
